/**
 * DOM 数据增强器
 * 优先级：2
 * 职责：从 DOM 提取数据（注意：不再从 DOM 读取业务标识）
 *
 * ⚠️ 重要说明：
 * 1. 新方案严格要求：所有业务标识必须通过 Track 组件传入（通过 data props）
 * 2. DOMEnricher 不再从 DOM 读取业务标识，避免维护问题
 * 3. 如果必填字段缺失，会在校验层直接报错阻断
 * 4. 上下文数据（如 search_word）由上下文管理器统一管理，不需要从 DOM 读取
 * 5. 这样设计可以确保数据来源清晰，避免"数据从哪里来"的困惑
 */

import { DataEnricher, EnrichContext } from "./types";

export class DOMEnricher implements DataEnricher {
  name = "DOMEnricher";
  priority = 2;

  shouldEnrich(context: EnrichContext): boolean {
    return !!context.targetNode;
  }

  enrich(context: EnrichContext): Record<string, any> {
    const { trackData } = context;

    // ❌ 不再从 DOM 读取业务标识
    // 所有业务标识必须通过 Track 组件的 data props 传入
    // 如果缺失，会在 Validator 层校验失败并报错

    // ❌ 不再提取上下文数据（如 search_word、search_word_type）
    // 这些数据由上下文管理器统一管理

    // ℹ️ 开发提示
    if (process.env.NODE_ENV === "development") {
      console.log(
        "[DOMEnricher] ℹ️ 业务标识必须通过 Track 组件传入，不再从 DOM 读取"
      );
    }

    return trackData;
  }
}
